import React, { useState, useEffect, useCallback } from 'react';
import { testimonials } from '../mockData';

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const next = useCallback(() => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  }, []);

  const prev = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? testimonials.length - 1 : prev - 1
    );
  };

  useEffect(() => {
    const interval = setInterval(next, 12000);
    return () => clearInterval(interval);
  }, [next]);

  return (
    <section className="relative text-white py-16 sm:py-24 md:py-32 overflow-hidden">
      {/* Asian-Inspired Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-amber-900/20 via-red-900/30 to-black"></div>
      <div className="absolute inset-0 bg-gradient-to-tr from-black via-rose-900/15 to-black"></div>
      <div className="absolute inset-0 bg-gradient-to-bl from-slate-900/20 via-black to-amber-800/10"></div>
      
      {/* Asian Pattern Overlays */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
      }}></div>
      
      {/* Asian-Inspired Color Gradients */}
      <div className="absolute top-0 left-1/4 w-64 sm:w-80 md:w-96 h-64 sm:h-80 md:h-96 bg-gradient-to-br from-amber-600/8 to-rose-600/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-1/4 w-64 sm:w-80 md:w-96 h-64 sm:h-80 md:h-96 bg-gradient-to-tl from-red-700/8 to-amber-700/5 rounded-full blur-3xl"></div>
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[400px] sm:w-[500px] md:w-[700px] h-[400px] sm:h-[500px] md:h-[700px] bg-gradient-to-r from-rose-500/4 via-red-500/3 to-amber-500/4 rounded-full blur-3xl"></div>
      
      {/* Subtle Asian Corner Accents */}
      <div className="absolute top-4 sm:top-8 left-4 sm:left-8 w-16 sm:w-32 h-16 sm:h-32 border-t-2 border-l-2 border-amber-500/20"></div>
      <div className="absolute top-4 sm:top-8 right-4 sm:right-8 w-16 sm:w-32 h-16 sm:h-32 border-t-2 border-r-2 border-rose-500/20"></div>
      <div className="absolute bottom-4 sm:bottom-8 left-4 sm:left-8 w-16 sm:w-32 h-16 sm:h-32 border-b-2 border-l-2 border-rose-500/20"></div>
      <div className="absolute bottom-4 sm:bottom-8 right-4 sm:right-8 w-16 sm:w-32 h-16 sm:h-32 border-b-2 border-r-2 border-amber-500/20"></div>
      <div className="container mx-auto px-4 sm:px-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Quote Marks */}
          <div className="text-6xl sm:text-8xl md:text-9xl font-serif text-white/10 leading-none mb-4 sm:mb-8">
            ''
          </div>

          {/* Testimonial Content */}
          <div className="min-h-[250px] sm:min-h-[300px] flex flex-col items-center justify-center">
            <blockquote
              key={currentIndex}
              className="mb-6 sm:mb-8"
              style={{
                animation: 'fadeIn 0.8s ease-out'
              }}
            >
              <p className="text-lg sm:text-2xl md:text-3xl lg:text-4xl font-light leading-relaxed mb-6 sm:mb-8 px-2">
                ''{testimonials[currentIndex].quote}''
              </p>
            </blockquote>

            <div
              className="flex flex-col items-center gap-1 sm:gap-2"
              style={{
                animation: 'fadeIn 0.8s ease-out 0.2s both'
              }}
            >
              <h4 className="text-lg sm:text-xl md:text-2xl font-bold">
                {testimonials[currentIndex].name}
              </h4>
              <p className="text-xs sm:text-sm md:text-base text-gray-400">
                {testimonials[currentIndex].role}
              </p>
            </div>
          </div>

          {/* Navigation */}
          <div className="flex items-center justify-center gap-4 mt-8 sm:mt-10 md:mt-12">
            {/* Dots */}
            <div className="flex gap-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className={`w-2 h-2 rounded-full transition-all duration-300 ${
                    index === currentIndex
                      ? 'bg-white w-6 sm:w-8'
                      : 'bg-white/30 hover:bg-white/50'
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </section>
  );
};

export default Testimonials;